import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Operator} from '../../core/_models'
import {TOKENS} from '../../../../../../components/design-system'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<Operator>>
}

const baseHeader: React.CSSProperties = {
  padding: '18px 20px',
  backgroundColor: TOKENS.color.surfaceStrong,
  borderBottom: `1px solid ${TOKENS.color.border}`,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  color: '#334155',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  cursor: 'pointer',
}

const OperatorCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => state.sort && state.sort === id, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    if (id === 'actions' || id === 'selection') return
    if (!isSelectedForSorting) {
      updateState({sort: id, order: 'asc', ...initialQueryState})
      return
    }
    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        updateState({sort: id, order: 'desc', ...initialQueryState})
        return
      }
      updateState({sort: undefined, order: undefined, ...initialQueryState})
    }
  }

  const isActions = id === 'actions'
  const style: React.CSSProperties = { ...baseHeader, textAlign: isActions ? 'right' : 'left' }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className, isSelectedForSorting && order !== undefined && `table-sort-${order}`)}
      style={style}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {OperatorCustomHeader}
